import React from 'react';
import { Heart, MessageCircle, Eye, TrendingUp, Flame, Award, Users, Clock, Star, Trophy, Gift } from 'lucide-react';

export const UserLevelCardPublicView = ({ stats, isLoading, username }) => {

    console.log('HHJH : ', stats)
  // Loading state
  if (isLoading) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #333 0%, #444 100%)',
        color: 'white',
        padding: '24px',
        borderRadius: '20px',
        marginBottom: '24px',
        width: '300px',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{ textAlign: 'center', color: '#888' }}>
          Loading stats...
        </div>
      </div>
    );
  }

  // Error or no stats state
  if (!stats) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #333 0%, #444 100%)',
        color: 'white',
        padding: '24px',
        borderRadius: '20px',
        marginBottom: '24px',
        width: '300px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '100px',
          height: '100px',
          background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          transform: 'translate(30px, -30px)'
        }} />
        
        <div style={{
          textAlign: 'center',
          padding: '20px 0',
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px auto',
            border: '2px solid rgba(255, 255, 255, 0.2)'
          }}>
            <Users size={24} color="rgba(255, 255, 255, 0.5)" />
          </div>
          
          <h3 style={{
            margin: '0 0 8px 0',
            fontSize: '16px',
            fontWeight: '600',
            color: 'white'
          }}>
            Stats Unavailable
          </h3>
          
          <p style={{
            margin: '0',
            fontSize: '13px',
            color: 'rgba(255, 255, 255, 0.6)',
            lineHeight: '1.4'
          }}>
            Unable to load user statistics
          </p>
        </div>
      </div>
    );
  }

  // Calculate progress percentage
  const nextLevelThreshold = stats.next_level_threshold || stats.get_next_level_threshold || stats.nextLevelXp || 100;
  const progressPercentage = Math.min((stats.xp / nextLevelThreshold) * 100, 100);

  return (
    <div style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      padding: '24px',
      borderRadius: '20px',
      marginBottom: '24px',
      width: '300px',
      position: 'relative',
      overflow: 'hidden',
      boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100px',
        height: '100px',
        background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
        borderRadius: '50%',
        transform: 'translate(30px, -30px)'
      }} />
      
      {/* Header with level and streak */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '20px',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '50px',
            height: '50px',
            background: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
            fontWeight: 'bold',
            border: '2px solid rgba(255, 255, 255, 0.3)'
          }}>
            {stats.UserLevel || 1}
          </div>
          <div>
            <h3 style={{ margin: 0, fontWeight: '700', fontSize: '16px' }}>
              Level {stats.UserLevel || 1}
            </h3>
            <p style={{ margin: 0, color: 'rgba(255, 255, 255, 0.8)', fontSize: '12px' }}>
              {username ? `${username}'s Profile` : 'User Profile'}
            </p>
          </div>
        </div>
        
        {stats.streak > 0 && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            padding: '6px 10px',
            borderRadius: '14px',
            fontSize: '11px',
            fontWeight: '600'
          }}>
            <Flame size={12} />
            {stats.streak}
          </div>
        )}
      </div>
      
      {/* XP Progress Bar */}
      {stats.xp !== undefined && (
        <div style={{ marginBottom: '20px', position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '12px',
            marginBottom: '6px',
            color: 'rgba(255, 255, 255, 0.9)'
          }}>
            <span>XP Progress</span>
            <span>{stats.xp || 0}/{nextLevelThreshold}</span>
          </div>
          <div style={{
            width: '100%',
            height: '6px',
            background: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${progressPercentage}%`,
              height: '100%',
              background: 'linear-gradient(90deg, #fbbf24 0%, #f59e0b 100%)',
              borderRadius: '3px',
              transition: 'width 0.8s cubic-bezier(0.4, 0, 0.2, 1)'
            }} />
          </div>
        </div>
      )}
      
      {/* Stats Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '12px',
        marginBottom: '16px',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '12px',
          borderRadius: '12px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '4px' }}>
            {stats.reputation || 0}
          </div>
          <div style={{ fontSize: '11px', color: 'rgba(255, 255, 255, 0.8)' }}>
            Reputation
          </div>
        </div>
        
        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '12px',
          borderRadius: '12px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '4px' }}>
            {((stats.total_posts || 0) + (stats.threads || 0))}
          </div>
          <div style={{ fontSize: '11px', color: 'rgba(255, 255, 255, 0.8)' }}>
            Posts
          </div>
        </div>
        
        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '12px',
          borderRadius: '12px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '4px' }}>
            {stats.total_comments || 0}
          </div>
          <div style={{ fontSize: '11px', color: 'rgba(255, 255, 255, 0.8)' }}>
            Comments
          </div>
        </div>
        
        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '12px',
          borderRadius: '12px',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '18px', fontWeight: '700', marginBottom: '4px' }}>
            {stats.total_upvotes || 0}
          </div>
          <div style={{ fontSize: '11px', color: 'rgba(255, 255, 255, 0.8)' }}>
            Upvotes
          </div>
        </div>
      </div>
      
      {/* Badges */}
      {stats.badges && stats.badges.length > 0 && (
        <div style={{
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{
            fontSize: '12px',
            color: 'rgba(255, 255, 255, 0.8)',
            marginBottom: '8px',
            fontWeight: '600'
          }}>
            Achievements
          </div>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px'
          }}>
            {stats.badges.slice(0, 3).map((badge, index) => (
              <span key={index} style={{
                fontSize: '10px',
                background: 'rgba(255, 255, 255, 0.2)',
                padding: '3px 8px',
                borderRadius: '10px',
                fontWeight: '500'
              }}>
                {typeof badge === 'string' ? badge : badge.name || 'Badge'}
              </span>
            ))}
            {stats.badges.length > 3 && (
              <span style={{
                fontSize: '10px',
                background: 'rgba(255, 255, 255, 0.15)',
                padding: '3px 8px',
                borderRadius: '10px',
                fontWeight: '500',
                color: 'rgba(255, 255, 255, 0.7)'
              }}>
                +{stats.badges.length - 3} more
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};